//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import { FeatureNames } from '@bvengineering/curalate-features';
import template from './galleries-menu.html';

import { dashboardStatesByName as states } from '../../top-level-states';

angular.module('curalate').component('galleriesMenu', {
  template,
  controller: [
    'SessionVarsService',
    function (SessionVarsService) {
      this.$onInit = () => {
        this.isGalleriesEnabled = states.galleries.data.hasAccess();
        this.isInstashopEnabled = states.instashop.data.hasAccess();
        this.isConversationsEnabled = states.conversations.data.hasAccess();
        this.isShowroomReportingEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.TributarySelfServe,
        );
        this.isEmailBuilderEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.EmailBuilder,
        );
        this.isGoogleAssetFeedsEnabled = SessionVarsService.isFeatureEnabled(
          FeatureNames.AssetFeedTagging,
        );
        this.isBazaarvoiceSyndicationEnabled =
          SessionVarsService.isFeatureEnabled(
            FeatureNames.BazaarvoiceNetworkSyndicationFrontend,
          );
      };
    },
  ],
});
